import axios from "@/repositories/client";

axios.getCancellationPolicies = (hotel, pagination, dropdown) => {

  let options = {
    params: {
      skip: pagination.size * (pagination.page - 1),
      take: pagination.size
    }
  };

  return axios.get(`athena/v1/hotels/${hotel}/cancellation-policies`, options)
    .then(response => {
      if(!dropdown)
        return response.data;
      else
        return response.data.data.map(policy => ({text: policy.name, value: policy.id}));
    });
};

axios.getCancellationPolicy = (hotel, policy) => {
  return axios.get(`athena/v1/hotels/${hotel}/cancellation-policies/${policy}`)
    .then(response => {
      return response.data.data;
    });
};

axios.savePolicy = (hotel, policy) => {
  let url = `athena/v1/hotels/${hotel}/cancellation-policies` + (policy.id ? `/${policy.id}` : '');
  let verb = policy.id ? 'PUT' : 'POST';

  return axios.request({method: verb, url: url, data: policy})
    .then(response => {
      return response.data.data;
    });
};

axios.destroyPolicy = (hotel, policy) => {
  return axios.delete(`athena/v1/hotels/${hotel}/cancellation-policies/${policy}`)
    .then(response => {
      return response.data;
    });
};

axios.getPaymentPolicies = (hotel, pagination, dropdown) => {

  dropdown = dropdown || false;

  let options = {
    params: {
      skip: pagination.size * (pagination.page - 1),
      take: pagination.size
    }
  };

  return axios.get(`athena/v1/hotels/${hotel}/payment-policies`, options)
    .then(response => {
      if(!dropdown)
        return response.data;
      else
        return response.data.data.map(policy => ({text: policy.name, value: policy.id}));
    });
};

axios.getPaymentPolicy = (hotel, policy) => {
  return axios.get(`athena/v1/hotels/${hotel}/payment-policies/${policy}`)
    .then(response => {
      return response.data.data;
    });
};

axios.savePaymentPolicy = (hotel, policy) => {
  let url = `athena/v1/hotels/${hotel}/payment-policies` + (policy.id ? `/${policy.id}` : '');
  let verb = policy.id ? 'PUT' : 'POST';

  return axios.request({method: verb, url: url, data: policy})
    .then(response => {
      return response.data.data;
    });
};

axios.destroyPaymentPolicy = (hotel, policy) => {
  return axios.delete(`athena/v1/hotels/${hotel}/payment-policies/${policy}`)
    .then(response => {
      return response.data;
    });
};

export default axios;